import React from "react";
import { Row, Col, Form, Input } from "antd";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

function ControlledDetailsInputField({
  name,
  control,
  label,
  rules = {},
  errors,
  required = false,
  type = "text",
}) {
  return (
    <Form.Item
      label={label}
      required={required}
      validateStatus={errors[name] ? "error" : ""}
      help={errors[name]?.message}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => <Input {...field} type={type} />}
      />
    </Form.Item>
  );
}

ControlledDetailsInputField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  errors: PropTypes.object.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string,
};

export default function ProfessionalDetailsIdentityFields({
  t,
  control,
  errors,
  keys,
}) {
  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <ControlledDetailsInputField
            name="firstname"
            control={control}
            errors={errors}
            label={t(keys.labelFirstName)}
            required
            rules={{
              required: t(keys.errorRequiredFirstName),
              minLength: { value: 2, message: t(keys.errorFirstNameMinLength) },
            }}
          />
        </Col>

        <Col span={12}>
          <ControlledDetailsInputField
            name="lastname"
            control={control}
            errors={errors}
            label={t(keys.labelLastName)}
            required
            rules={{
              required: t(keys.errorRequiredLastName),
              minLength: { value: 2, message: t(keys.errorLastNameMinLength) },
            }}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <ControlledDetailsInputField
            name="email"
            control={control}
            errors={errors}
            label={t(keys.labelEmail)}
            required
            type="email"
            rules={{
              required: t(keys.errorRequiredEmail),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: t(keys.errorInvalidEmailFormat),
              },
            }}
          />
        </Col>

        <Col span={12}>
          <ControlledDetailsInputField
            name="phoneNumber"
            control={control}
            errors={errors}
            label={t(keys.labelPhoneNumber)}
            required
            rules={{
              required: t(keys.errorRequiredPhoneNumber),
              pattern: {
                value: /^[0-9+\s-]{8,}$/,
                message: t(keys.errorInvalidPhoneNumber),
              },
            }}
          />
        </Col>
      </Row>
    </>
  );
}

ProfessionalDetailsIdentityFields.propTypes = {
  t: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  keys: PropTypes.shape({
    labelFirstName: PropTypes.string.isRequired,
    errorRequiredFirstName: PropTypes.string.isRequired,
    errorFirstNameMinLength: PropTypes.string.isRequired,
    labelLastName: PropTypes.string.isRequired,
    errorRequiredLastName: PropTypes.string.isRequired,
    errorLastNameMinLength: PropTypes.string.isRequired,
    labelEmail: PropTypes.string.isRequired,
    errorRequiredEmail: PropTypes.string.isRequired,
    errorInvalidEmailFormat: PropTypes.string.isRequired,
    labelPhoneNumber: PropTypes.string.isRequired,
    errorRequiredPhoneNumber: PropTypes.string.isRequired,
    errorInvalidPhoneNumber: PropTypes.string.isRequired,
  }).isRequired,
};
